import { __extends } from "tslib";
import { DescribeStreamConsumerInput, DescribeStreamConsumerOutput } from "../models/models_0";
import { deserializeAws_json1_1DescribeStreamConsumerCommand, serializeAws_json1_1DescribeStreamConsumerCommand, } from "../protocols/Aws_json1_1";
import { getSerdePlugin } from "@aws-sdk/middleware-serde";
import { Command as $Command } from "@aws-sdk/smithy-client";
var DescribeStreamConsumerCommand = /** @class */ (function (_super) {
    __extends(DescribeStreamConsumerCommand, _super);
    // Start section: command_properties
    // End section: command_properties
    function DescribeStreamConsumerCommand(input) {
        var _this = 
        // Start section: command_constructor
        _super.call(this) || this;
        _this.input = input;
        return _this;
        // End section: command_constructor
    }
    DescribeStreamConsumerCommand.prototype.resolveMiddleware = function (clientStack, configuration, options) {
        this.middlewareStack.use(getSerdePlugin(configuration, this.serialize, this.deserialize));
        var stack = clientStack.concat(this.middlewareStack);
        var logger = configuration.logger;
        var clientName = "KinesisClient";
        var commandName = "DescribeStreamConsumerCommand";
        var handlerExecutionContext = {
            logger: logger,
            clientName: clientName,
            commandName: commandName,
            inputFilterSensitiveLog: DescribeStreamConsumerInput.filterSensitiveLog,
            outputFilterSensitiveLog: DescribeStreamConsumerOutput.filterSensitiveLog,
        };
        if (typeof logger.info === "function") {
            logger.info({
                clientName: clientName,
                commandName: commandName,
            });
        }
        var requestHandler = configuration.requestHandler;
        return stack.resolve(function (request) {
            return requestHandler.handle(request.request, options || {});
        }, handlerExecutionContext);
    };
    DescribeStreamConsumerCommand.prototype.serialize = function (input, context) {
        return serializeAws_json1_1DescribeStreamConsumerCommand(input, context);
    };
    DescribeStreamConsumerCommand.prototype.deserialize = function (output, context) {
        return deserializeAws_json1_1DescribeStreamConsumerCommand(output, context);
    };
    return DescribeStreamConsumerCommand;
}($Command));
export { DescribeStreamConsumerCommand };
//# sourceMappingURL=DescribeStreamConsumerCommand.js.map